import { RESPONSE_TYPES } from "@constants/response-types";
import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";
import { AxiosResponse } from "axios";

export class AppService extends HttpService {
  fetchSuggestedQuestions = async (
    baseAuthUrl: string
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.get(
        `${baseAuthUrl}/api/suggestion-questions`
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  fetchFaqs = async (baseAuthUrl: string, payload: any) => {
    try {
      const { data } = await this.get(`${baseAuthUrl}/api/faqs`, payload);

      return data?.data;
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  logEvent = async (baseAuthUrl: string, data: any): Promise<TObject> => {
    try {
      const apiResponse = await this.post(
        `${baseAuthUrl}/api/event-logs`,
        data
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };

  getReports = async (baseAuthUrl: string, payload: any) => {
    try {
      const { data } = await this.get(
        `${baseAuthUrl}/api/reports/dashboard-data`,
        payload
      );
      return data?.data?.files;
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  viewReports = async (baseAuthUrl: string, payload: any) => {
    try {
      const { data } = await this.get(
        `${baseAuthUrl}/api/extraction-reviews`,
        payload
      );
      console.log(data?.data);
      return data?.data;
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  changePassword = async (baseAuthUrl: string, payload: any) => {
    try {
      const response = (await this.patch(
        `${baseAuthUrl}/api/user/password/change`,
        payload
      )) as any;
      return response?.data?.data ?? response?.data ?? { success: true };
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  toggleThreadPin = async (baseAuthUrl: string, threadId: number | string) => {
    try {
      const response = (await this.patch(
        `${baseAuthUrl}/api/thread/${threadId}/toggle-pin`,
        {}
      )) as any;
      return response?.data?.data ?? response?.data ?? { success: true };
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  deleteThread = async (baseAuthUrl: string, threadId: number | string) => {
    try {
      const response = (await this.delete(
        `${baseAuthUrl}/api/thread/${threadId}`
      )) as any;
      return response?.data?.data ?? response?.data ?? { success: true };
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };

  renameThread = async (
    baseAuthUrl: string,
    threadId: number | string,
    payload: { name: string }
  ) => {
    try {
      const response = (await this.patch(
        `${baseAuthUrl}/api/thread/${threadId}/rename`,
        payload
      )) as any;
      return response?.data?.data ?? response?.data ?? { success: true };
    } catch (error) {
      throw prepareErrorResponse(error);
    }
  };
}
